/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_NoteInputs */

const en_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Note`)
};

const fr_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note generale`)
};

const de_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Anmerkung`)
};

const it_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota generale`)
};

const ru_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общее примечание`)
};

const es_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota general`)
};

const zh_cn2_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般说明`)
};

const ja_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的な注意事項`)
};

const hi_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य नोट`)
};

const pt_pt2_manual_qc_type_note = /** @type {(inputs: Manual_Qc_Type_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota geral`)
};

/**
* | output |
* | --- |
* | "General Note" |
*
* @param {Manual_Qc_Type_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_note = /** @type {((inputs?: Manual_Qc_Type_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_type_note(inputs)
	if (locale === "de") return de_manual_qc_type_note(inputs)
	if (locale === "it") return it_manual_qc_type_note(inputs)
	if (locale === "ru") return ru_manual_qc_type_note(inputs)
	if (locale === "es") return es_manual_qc_type_note(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_type_note(inputs)
	if (locale === "ja") return ja_manual_qc_type_note(inputs)
	if (locale === "hi") return hi_manual_qc_type_note(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_type_note(inputs)
	return en_manual_qc_type_note(inputs)
});